import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "lc_bsmain"
};
const _hoisted_2 = {
  class: "lc_bsmain"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_5 = {
  key: 1,
  class: "lc_bsmain lc_taskmain"
};
const _hoisted_6 = {
  key: 0,
  class: "lcbhcontent",
  style: {
    "max-height": "400px",
    "overflow-y": "auto"
  }
};
const _hoisted_7 = {
  class: "lc_bhitem"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import { getUsers, getCate, getBrand } from '../../utils/lc';
import { infoForm, taskForm } from '../../utils/lc_data';
import { reactive, ref, onMounted, watch, getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';
/* 数据 */

export default {
  __name: 'lcBaseInfo',
  props: ['type', 'kmT0tag'],
  setup(__props, {
    expose: __expose
  }) {
    let {
      proxy
    } = getCurrentInstance(); // this替代
    const prop = __props;
    const html = reactive({
      datelist: [{
        label: '项目开始日期',
        vModel: 'start_time'
      }, {
        label: '项目发布日期',
        vModel: 'issue_time'
      }, {
        label: '项目量产日期',
        vModel: 'product_time'
      }, {
        label: '项目上架日期',
        vModel: 'online_time'
      }, {
        label: '项目结束日期',
        vModel: 'end_time'
      }]
    });
    const upLoadQuery = ref({
      type: 'images',
      language_id: 1
    });
    const upLoadUrl = ref(process.env.VUE_APP_API_BASEURL + 'admin/project/upload/file');
    const formatset = ref('YYYY/MM/DD');
    let imageUrl = ref('');
    const form = reactive(JSON.parse(JSON.stringify(infoForm)));
    const taskform = reactive(JSON.parse(JSON.stringify(taskForm)));
    let lastPage = ref(0);
    let data = reactive({
      checked: false,
      //全选
      withcredentials: true,
      reject: [],
      // 驳回原因列表
      bhshow: false,
      // 驳回原因弹框
      userlist: [],
      userlistall: [],
      userSet: {
        page: 1,
        size: 99999,
        nickname: ''
      }
    });
    let cate = reactive({
      cateArry: [],
      cateSet: {
        cate_name: '',
        pid: '',
        is_tree: 1
      }
    });
    let brandArry = ref([]);
    watch(() => form.brand_ids, (newValue, oldValue) => {
      data.checked = brandArry.value.length == newValue.length ? true : false;
    });
    /* 初始化 */
    // 获取品牌数据
    getBrand().then(res => {
      brandArry.value = res;
    });
    // 获取产品分类数据
    getCate(cate.cateSet).then(res => {
      cate.cateArry = res;
    });
    // 挂载初始化---生命周期
    onMounted(() => {
      getUsers({
        page: 1,
        size: 99999,
        nickname: ''
      }).then(res => {
        lastPage.value = res.last_page;
        data.userlistall = JSON.parse(JSON.stringify(res.data));
      });
      init();
    });
    /* 方法 */
    function init(value) {
      data.userSet.page = 1;
      data.userSet.nickname = value;
      getUsers(data.userSet).then(res => {
        lastPage.value = res.last_page;
        data.userlist = JSON.parse(JSON.stringify(res.data));
        data.userlistall = JSON.parse(JSON.stringify(res.data));
      });
    }
    // 远程搜索人
    function userremoteMethod(value) {
      proxy.$http.showLoading(false).get('project/data/user', {
        nickname: value,
        page: 1,
        size: 99999
      }).then(res => {
        data.userlistall = res.data.data;
        data.userlist = res.data.data;
      });
    }
    // 品牌全选
    function selectAll() {
      form.brand_ids = [];
      if (data.checked) {
        brandArry.value.map(item => {
          form.brand_ids.push(item.id);
        });
      } else {
        form.brand_ids = [];
      }
    }
    //
    function handleClose() {
      data.bhshow = false;
    }
    // 项目负责人懒加载
    function loadmore() {
      data.userSet.page++;
      if (data.userSet.page <= lastPage.value) {
        getUsers(data.userSet).then(res => {
          data.userlist = [...JSON.parse(JSON.stringify(data.userlist)), ...res.data];
        });
      }
    }
    function handleAvatarSuccess(response, uploadFile) {
      if (response.status == 200) {
        imageUrl.value = response.data.fileurl ? response.data.fileurl : '';
        form.image = imageUrl.value;
        proxy.$refs.uploadRef.clearFiles();
      }
    }
    function beforeAvatarUpload(file) {
      const isJPG = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        ElMessage.error('上传图片格式不对!');
      }
      if (!isLt2M) {
        ElMessage.error('上传图片大小不能超过 1MB!');
      }
      return isJPG && isLt2M;
    }
    function remoteMethod(value) {
      init(value);
    }
    /* 曝露方法或者属性值给父组件或者其他子组件用 */
    __expose({
      form,
      imageUrl,
      taskform,
      data
    });
    return (_ctx, _cache) => {
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["lc-bsinfo", {
          'lc-taskbsinfo': __props.type == 'taskInfo'
        }])
      }, [_cache[32] || (_cache[32] = _createElementVNode("div", {
        class: "lc_title"
      }, "基本信息", -1)), __props.type == 'info' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[29] || (_cache[29] = _createElementVNode("label", {
        style: {
          "margin-right": "16px",
          "display": "block"
        }
      }, "项目图片", -1)), _createVNode(_component_el_upload, {
        ref: "uploadRef",
        class: "avatar-uploader",
        action: upLoadUrl.value,
        "show-file-list": false,
        "on-success": handleAvatarSuccess,
        "before-upload": beforeAvatarUpload,
        data: upLoadQuery.value,
        "with-credentials": _unref(data).withcredentials
      }, {
        default: _withCtx(() => [_unref(imageUrl) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(imageUrl),
          class: "avatar",
          style: {
            "width": "100%",
            "height": "100%"
          }
        }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("i", _hoisted_4))]),
        _: 1
      }, 8, ["action", "data", "with-credentials"])]), _createElementVNode("div", null, [_createVNode(_component_el_form, {
        "label-position": "right",
        model: form,
        "label-width": "112px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "项目名称",
            required: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              style: {
                "margin-left": "-6px"
              },
              maxlength: "80"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目负责人",
            required: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.leader_user_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.leader_user_id = $event),
              placeholder: "请选择",
              filterable: "",
              remote: "",
              "remote-method": userremoteMethod
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlist, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目状态",
            style: {
              "margin-left": "9px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.status_text,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.status_text = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目类型",
            style: {
              "margin-left": "11px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.type = $event),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "技术开发",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "产品开发",
                value: 2
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目代码",
            style: {
              "margin-left": "10px"
            },
            required: true,
            prop: "code"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.code,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.code = $event),
              maxlength: "80"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "项目编号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.sn,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.sn = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "产品分类",
            class: "lc_lcselect",
            required: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_cascader, {
              modelValue: form.cate_id,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.cate_id = $event),
              options: _unref(cate).cateArry,
              props: {
                expandTrigger: 'hover',
                value: 'id',
                label: 'name',
                children: 'children'
              },
              clearable: ""
            }, null, 8, ["modelValue", "options"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目预计开始日期",
            style: {
              "margin-left": "13px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: form.plan_start_time,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.plan_start_time = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "项目预计结束日期",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: form.plan_end_time,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.plan_end_time = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(html.datelist, item => {
            return _openBlock(), _createBlock(_component_el_form_item, {
              label: item.label,
              key: item.label
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 11
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  type: "date",
                  placeholder: "选择日期",
                  modelValue: form[item.vModel],
                  "onUpdate:modelValue": $event => form[item.vModel] = $event,
                  style: {
                    "width": "100%",
                    "margin-left": "-7px"
                  },
                  "value-format": formatset.value,
                  format: formatset.value,
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "value-format", "format"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["label"]);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "项目优先级",
              style: {
                "margin-left": "-8px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.level,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.level = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "P0",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "P1",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "P2",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "P3",
                  value: 3
                }), _createVNode(_component_el_option, {
                  label: "P4",
                  value: 4
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "项目包含品牌",
              class: "lcse2",
              required: true,
              style: {
                "width": "500px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.brand_ids,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.brand_ids = $event),
                multiple: "",
                placeholder: "请选择",
                style: {
                  "width": "inherit"
                },
                size: "small"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                  modelValue: _unref(data).checked,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(data).checked = $event),
                  onChange: selectAll,
                  style: {
                    "margin-left": "20px"
                  }
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode(" 全选 ")])),
                  _: 1,
                  __: [30]
                }, 8, ["modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brandArry), item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.name,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])) : _createCommentVNode("", true), __props.type == 'taskInfo' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        "label-position": "right",
        model: taskform,
        "label-width": "112px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 5
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "任务编码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.sn,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => taskform.sn = $event),
              style: {
                "margin-left": "-6px"
              },
              maxlength: "80",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务名称",
            style: {
              "margin-left": "5px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.name,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => taskform.name = $event),
              style: {
                "margin-left": "-6px"
              },
              maxlength: "80",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务负责人",
            style: {
              "margin-left": "11px"
            },
            required: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: taskform.leader_user_id,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => taskform.leader_user_id = $event),
              placeholder: "请选择",
              filterable: "",
              remote: "",
              "remote-method": userremoteMethod
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlistall, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "任务审核人",
            style: {
              "margin-left": "11px"
            },
            required: true
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: taskform.reviewer_user_id,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => taskform.reviewer_user_id = $event),
              placeholder: "请选择",
              filterable: "",
              remote: "",
              "remote-method": userremoteMethod
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlistall, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务状态",
            style: {
              "margin-left": "9px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.task_status_text,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => taskform.task_status_text = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "业务审核状态",
            style: {
              "margin-left": "9px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.examine_status_text,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => taskform.examine_status_text = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 16
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "所属项目编号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.project_sn,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => taskform.project_sn = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属项目名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: taskform.project_name,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => taskform.project_name = $event),
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "要求完成时间",
            style: {
              "margin-left": "13px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: taskform.required_time_text,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => taskform.required_time_text = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value,
                disabled: ""
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预计开始日期",
            style: {
              "margin-left": "13px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: taskform.plan_start_time_text,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => taskform.plan_start_time_text = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "预计完成日期",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: taskform.plan_end_time_text,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => taskform.plan_end_time_text = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "完成日期",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: taskform.end_time_text,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => taskform.end_time_text = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value,
                disabled: ""
              }, null, 8, ["modelValue", "value-format", "format"])]),
              _: 1
            })]),
            _: 1
          }), __props.kmT0tag == 'km' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "T0日期",
            style: {
              "margin-left": "4px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 11
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                type: "date",
                placeholder: "选择日期",
                modelValue: taskform.t0_time_text,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => taskform.t0_time_text = $event),
                style: {
                  "width": "100%",
                  "margin-left": "-10px"
                },
                "value-format": formatset.value,
                format: formatset.value,
                disabled: taskform.examine_status_text == '未下推' || taskform.examine_status_text == '已结束'
              }, null, 8, ["modelValue", "value-format", "format", "disabled"])]),
              _: 1
            })]),
            _: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_unref(data).reject && _unref(data).reject.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "l-button lcbhbt",
            onClick: _cache[25] || (_cache[25] = $event => _unref(data).bhshow = true)
          }, " 查看任务审核驳回明细")) : _createCommentVNode("", true)], 64))]),
          _: 1
        }), __props.kmT0tag == 'km' ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0
        }, {
          default: _withCtx(() => [_unref(data).reject && _unref(data).reject.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "l-button lcbhbt",
            onClick: _cache[26] || (_cache[26] = $event => _unref(data).bhshow = true)
          }, " 查看任务审核驳回明细")) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: "驳回原因",
        modelValue: _unref(data).bhshow,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => _unref(data).bhshow = $event),
        "before-close": handleClose,
        width: "500px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[27] || (_cache[27] = $event => _unref(data).bhshow = false)
        }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("确 定")])),
          _: 1,
          __: [31]
        })])]),
        default: _withCtx(() => [_unref(data).reject && _unref(data).reject.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).reject, (it, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, "驳回时间:" + _toDisplayString(it.create_time_text), 1), _createElementVNode("div", null, "驳回人：" + _toDisplayString(it.create_user_name), 1), _createElementVNode("div", null, _toDisplayString(it.msg), 1)])]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无记录 "))]),
        _: 1
      }, 8, ["modelValue"])], 2);
    };
  }
};